import {
	createContext,
	useCallback,
	useState,
	useSyncExternalStore,
} from 'react';
import API from 'services/api';
import _ from 'lodash';
import toast from 'react-hot-toast';

export const MasterDataContext = createContext({});

const MasterDataProvider = props => {
	const [users, setUsers] = useState([]);
	const [usersasFilter, setUsersasFilter] = useState([]);
	const [dataUser, setDataUser] = useState({});
	const [roles, setRoles] = useState([]);
	const [dataRole, setDataRole] = useState({});

	const [companies, setCompanies] = useState([]);
	const [dataCompany, setDataCompany] = useState({});
	const [contacts, setContacts] = useState([]);
	const [dataContact, setDataContact] = useState({});
	const [contactbypage, setContactbyPage] = useState([]);

	const [listPermissions, setListPermissions] = useState([]);
	const [departements, setDepartements] = useState([]);
	const [masterClass, setMasterClass] = useState([]);
	const [detailMasterClass, setDetailMasterClass] = useState({});
	const [dataMasterClass, setDataMasterClass] = useState(null);
	const [masterTasks, setMasterTasks] = useState([]);
	const [alltasks, setAllTasks] = useState([]);
	const [detailMasterTasks, setDetailMasterTasks] = useState({});
	const [dataMasterTasks, setDataMasterTasks] = useState(null);
	const [searchContact, setSearchContact] = useState('');
	const [filterContact, setFilterContact] = useState('');
	const [dataFilterDropdown, setDataFilterDropdown] = useState(null);
	const [selectedCompany, setSelectedCompany] = useState('');
	const [masterevents, setMasterevents] = useState([]);
	const [allevents, setAllEvents] = useState([]);
	const [eventbynames, setEventbyNames] = useState([]);

	const [consultants, setConsultants] = useState([]);
	const [detailConsultant, setDetailConsultant] = useState({});

	const [taxrates, setTaxrates] = useState([]);
	const [taxRateDetail, setTaxRateDetail] = useState({});

	const [forms, setForms] = useState([]);

	const [isLoading, setLoading] = useState(false);

	// filter use on master tasks
	const [filterdiv, setFilterDiv] = useState(null);
	const [filtersubdiv, setFilterSubDiv] = useState(null);

	const [fcmtokens, setFcmTokens] = useState([]);
	const [userToSend, setUserToSend] = useState([]);

	const [isError, setIsError] = useState(false);

	// paten
	const [contactPaten, setcontactPaten] = useState([]);

	const getListDepartements = async params => {
		await API.getDepartements(params)
			.then(res => {
				const data = res.data;
				// console.log("data", data);
				setDepartements(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const getListPermissions = async () => {
		await API.getListPermissions()
			.then(res => {
				const data = res.data;
				// console.log("data", data);
				setListPermissions(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const getUsers = useCallback(async params => {
		await API.getAllUser(params)
			.then(res => {
				const { data } = res;
				// console.log("data", res.data);
				setUsers(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	}, []);

	const getUserasFilter = useCallback(async params => {
		await API.getUserasFilter(params)
			.then(res => {
				const { data } = res;
				setUsersasFilter(data);
			})
			.catch(err => {
				throw err;
			});
	}, []);

	const getUserReturnFCM = async sendbody => {
		return API.getUserReturnFCM(sendbody)
			.then(res => {
				const { data } = res;
				// console.log("data", res.data);
				let fdata = data.map(x => x.fcmtoken);

				setFcmTokens(fdata);
				setUserToSend(data);
				return data;
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const getRoles = useCallback(async params => {
		await API.getRoles(params).then(res => {
			const { data } = res;
			setRoles(data);
		});
	}, []);

	const getDataUser = useCallback(async (id, params) => {
		await API.getUser(id, params)
			.then(res => {
				const { data } = res.data;
				// console.log("Data ", data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	}, []);

	// Company
	const getCompanies = useCallback(async params => {
		await API.getAllCompanies(params)
			.then(res => {
				const { data } = res;
				// console.log("data", res.data);
				setCompanies(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	}, []);

	const getDataCompany = useCallback(async (id, params) => {
		await API.getCompany(id, params)
			.then(res => {
				const { data } = res;
				// console.log("Data ", data)

				setDataCompany(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	}, []);

	// Contacts
	const getContacts = useCallback(async params => {
		await API.getAllContacts(params)
			.then(res => {
				const { data } = res;
				setContacts(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	}, []);

	const getContactbyPage = params => {
		API.getContactbyPage(params)
			.then(res => {
				const { data } = res;
				setContactbyPage(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const getDataContact = useCallback(async (id, params) => {
		return await API.getContact(id, params)
			.then(res => {
				const { data } = res;

				setDataContact(data);
				return data;
			})
			.catch(err => {
				console.log('err', err);
				setIsError(err.message || 'An error occurred');
			});
	}, []);

	const postManyContact = data => {
		return API.postManyContact(data)
			.then(res => {
				const { data } = res;

				setDataContact(data);
				return data;
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const postManyContactWith = data => {
		return API.postManyContactWith(data)
			.then(res => {
				const { data } = res;

				setDataContact(data);
				return data;
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const getMasterClass = async params => {
		await API.getMasterClass(params)
			.then(res => {
				const { data } = res;
				setMasterClass(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const getDetailMasterClass = async _id => {
		await API.getMasterClass({ params: { _id } })
			.then(res => {
				const { data } = res;
				// console.log("Data ", data);
				setDetailMasterClass(data[0]);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const postMasterClass = sendData => {
		return API.postMasterClass(sendData)
			.then(res => {
				const { data } = res;
				setMasterClass([...masterClass, data?.data]);
				return { status: 200, data: data?.data };
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
				return { status: 404, data: err.message };
			});
	};

	const putMasterClass = (id, sendData) => {
		return API.putMasterClass(id, sendData)
			.then(res => {
				const { data } = res;
				let updated = masterClass.map(item =>
					item._id === id ? data?.data : item
				);
				let sortById = _.orderBy(updated, ['_id'], ['asc']);
				setMasterClass(sortById);
				return { status: 200, data: data };
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
				return { status: 404, data: err.message };
			});
	};

	const deleteMasterClass = id => {
		return API.deleteMasterClass(id)
			.then(res => {
				const { data } = res;
				setMasterClass(masterClass.filter(item => item._id !== id));
				return { status: 200, data: data?.data };
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
				return { status: 404, data: err.message };
			});
	};

	const getMasterTasks = async params => {
		return API.getMasterTasks(params)
			.then(res => {
				const { data } = res;
				let ftask = [];

				const valparse = JSON.parse(filterdiv);

				if (filterdiv) {
					let ftaskbydiv = data.filter(x => x.division?._id === valparse?._id);

					if (filtersubdiv) {
						if (valparse?.departement === 'Paten') {
							ftaskbydiv = data.filter(
								x =>
									x?.subs?.includes(filtersubdiv) &&
									x.division?._id === valparse?._id
							);
						} else {
							ftaskbydiv = data.filter(
								x =>
									x.subdivision === filtersubdiv &&
									x.division?._id === JSON.parse(filterdiv)?._id
							);
						}
					}

					setMasterTasks(ftaskbydiv);
				} else {
					setMasterTasks(data);
				}

				// if (filterdiv) {
				// 	console.log("true")
				// 	if (filtersubdiv) {
				// 		ftask = data.filter((x) => x.subdivision === filtersubdiv && x.division?._id === JSON.parse(filterdiv)?._id)
				// 	} else {
				// 		ftask = data.filter((x) => x.division?._id === JSON.parse(filterdiv)?._id)
				// 	}

				// 	setMasterTasks(ftask)
				// } else {

				// }

				// setMasterTasks(data)

				setAllTasks(data);
				setLoading(false);
				return data;
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
				return err;
			});
	};

	const getTaskPatent = async params => {
		try {
			let result = await API.getTaskPatent({ params });
			setMasterTasks(result.data);
			return result.data;
		} catch (err) {
			setIsError(err.message || 'An error occurred');
			throw err;
		}
	};

	const getMasterTasksToFiling = async params => {
		try {
			let result = await API.getMasterTasksToFiling({ params });
			setMasterTasks(result.data);
			return result.data;
		} catch (err) {
			setIsError(err.message || 'An error occurred');
			throw err;
		}
	};

	const getTasksToStatus = async params => {
		try {
			let result = await API.getTasksToStatus({ params });
			setMasterTasks(result.data);
			return result.data;
		} catch (err) {
			setIsError(err.message || 'An error occurred');
			throw err;
		}
	};

	const getMasterTasksToRecordal = async params => {
		try {
			let result = await API.getMasterTasksToRecordal();
			setMasterTasks(result.data);
			return result.data;
		} catch (err) {
			setIsError(err.message || 'An error occurred');
			throw err;
		}
	};

	const getMasterTasksToRenewal = async params => {
		try {
			let result = await API.getMasterTasksToRenewal();
			setMasterTasks(result.data);
			return result.data;
		} catch (err) {
			setIsError(err.message || 'An error occurred');
			throw err;
		}
	};

	const getTaskToOA = async params => {
		try {
			let result = await API.getTaskToOA();
			setMasterTasks(result.data);
			return result.data;
		} catch (err) {
			setIsError(err.message || 'An error occurred');
			throw err;
		}
	};

	const postMasterTasks = sendData => {
		return API.postMasterTasks(sendData)
			.then(res => {
				const { data } = res;
				getMasterTasks();
				return { status: 200, data: data?.data };
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
				return { status: 404, data: err.message };
			});
	};

	const deleteMasterTasks = id => {
		return API.deleteMasterTasks(id)
			.then(res => {
				const { data } = res;
				getMasterTasks();
				return { status: 200, data: data?.data };
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
				return { status: 404, data: err.message };
			});
	};

	const putMasterTasks = (id, sendData) => {
		return API.putMasterTasks(id, sendData)
			.then(res => {
				const { data } = res;
				getMasterTasks();
				return { status: 200, data: data };
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
				return { status: 404, data: err.message };
			});
	};

	const getMasterEvents = async params => {
		await API.getMasterEvents(params)
			.then(res => {
				const { data } = res;
				let fname = data?.map(x => x.name);
				setMasterevents(data);
				setAllEvents(data);
				setEventbyNames(fname);

				setLoading(false);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const postMasterEvent = sendData => {
		return API.postMasterEvent(sendData)
			.then(res => {
				const { data } = res;
				getMasterEvents();
				// setMasterevents([...masterevents, data?.data])
				return { status: 200, data: data?.data };
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
				return { status: 404, data: err.message };
			});
	};

	const deleteMasterEvent = id => {
		return API.deleteMasterEvent(id)
			.then(res => {
				const { data } = res;
				getMasterEvents();
				// setMasterevents(masterevents.filter((item) => item._id !== id))
				return { status: 200, data: data?.data };
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
				return { status: 404, data: err.message };
			});
	};

	const putMasterEvent = (id, sendData) => {
		return API.putMasterEvent(id, sendData)
			.then(res => {
				const { data } = res;
				getMasterEvents();
				return { status: 200, data: data };
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
				return { status: 404, data: err.message };
			});
	};

	const handleSearchContact = async e => {
		if (e) {
			if (dataFilterDropdown !== null) {
				const searchQuery = e?.target?.value.toString().toLowerCase();
				setSearchContact(searchQuery);
				const filtered = [
					'companyName',
					'contactPerson',
					'name',
					'phone',
					'fax',
					'email',
					'category',
					'address',
				].map((x, i) => {
					return dataFilterDropdown.filter(el => {
						if (el[x]) {
							return el[x].toString().toLowerCase().indexOf(searchQuery) !== -1;
						}
						return false;
					});
				});
				const dataset = _.maxBy(filtered, function (o) {
					return o.length;
				});
				setFilterContact(dataset);
			} else {
				const searchQuery = e?.target?.value.toString().toLowerCase();
				setSearchContact(searchQuery);
				const filtered = [
					'companyName',
					'contactPerson',
					'name',
					'phone',
					'fax',
					'email',
					'category',
					'address',
				].map((x, i) => {
					return contacts.filter(el => {
						if (el[x]) {
							return el[x].toString().toLowerCase().indexOf(searchQuery) !== -1;
						}
						return false;
					});
				});
				const dataset = _.maxBy(filtered, function (o) {
					return o.length;
				});
				setFilterContact(dataset);
			}
		} else {
			setSearchContact('');
			setFilterContact(contacts);
		}
	};

	const handleFilterByCompany = companyName => {
		setSelectedCompany(companyName);
		if (companyName) {
			if (filterContact !== '') {
				const filtered = filterContact.filter(
					el => el.company.name === companyName
				);
				console.log(filtered);
				setDataFilterDropdown(filtered);
			} else {
				const filtered = contacts.filter(el => el.company.name === companyName);
				console.log(filtered);
				setDataFilterDropdown(filtered);
			}
		} else {
			setSelectedCompany('');
			setDataFilterDropdown(contacts);
		}
	};

	// consultant master
	const getConsultants = params => {
		API.getConsultants(params)
			.then(res => {
				const data = res.data;
				setConsultants(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const putConsultant = (id, sendData) => {
		API.putConsultant(id, sendData)
			.then(res => {
				const { data } = res;
				getConsultants();
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const postConsultant = data => {
		API.postConsultant(data)
			.then(res => {
				getConsultants();
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const deleteConsultant = id => {
		API.deleteConsultant(id)
			.then(res => {
				const { data } = res;
				getConsultants();
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const getDetailConsultant = id => {
		API.getDetailConsultant(id)
			.then(res => {
				const { data } = res;
				setDetailConsultant(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	// taxrate master
	const getTaxRate = params => {
		API.getTaxRate(params)
			.then(res => {
				const data = res.data;
				setTaxrates(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const getTaxRatebyID = params => {
		API.getTaxRatebyID(params)
			.then(res => {
				const data = res.data;
				setTaxRateDetail(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const putTaxRate = (id, sendData) => {
		API.putTaxRate(id, sendData)
			.then(res => {
				const { data } = res;
				// getTaxRate()
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const postTaxRate = data => {
		API.postTaxRate(data)
			.then(res => {
				// getTaxRate()
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const deleteTaxRate = id => {
		API.deleteTaxRate(id)
			.then(res => {
				const { data } = res;
				// getTaxRate()
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	// paten
	const getCpatentbyPage = params => {
		API.getCpatentbyPage(params)
			.then(res => {
				const { data } = res;
				setcontactPaten(data);
			})
			.catch(err => {
				setIsError(err.message || 'An error occurred');
			});
	};

	const getDataContactPaten = useCallback(async (id, params) => {
		return await API.getCPatent(id, params)
			.then(res => {
				const { data } = res;

				setDataContact(data);
				return data;
			})
			.catch(err => {
				console.log('err', err);
				setIsError(err.message || 'An error occurred');
			});
	}, []);

	return (
		<MasterDataContext.Provider
			value={{
				users,
				roles,
				dataRole,
				dataUser,
				listPermissions,
				companies,
				contacts,
				dataCompany,
				dataContact,
				departements,

				setDataContact,

				usersasFilter,
				getUserasFilter,

				getUsers,
				getRoles,
				getDataUser,
				getListPermissions,
				getCompanies,
				getDataCompany,
				getContacts,
				getDataContact,
				contactbypage,
				getContactbyPage,

				postManyContact,
				postManyContactWith,

				getListDepartements,
				masterClass,
				setMasterClass,
				detailMasterClass,
				setDetailMasterClass,
				dataMasterClass,
				setDataMasterClass,
				getMasterClass,
				getDetailMasterClass,
				postMasterClass,
				deleteMasterClass,
				putMasterClass,
				getMasterTasks,

				getMasterTasksToFiling,
				getMasterTasksToRecordal,
				getMasterTasksToRenewal,
				getTasksToStatus,
				getTaskToOA,
				getTaskPatent,

				postMasterTasks,
				deleteMasterTasks,
				putMasterTasks,
				masterTasks,
				alltasks,
				setMasterTasks,
				detailMasterTasks,
				setDetailMasterTasks,
				setDataMasterTasks,

				getMasterEvents,
				postMasterEvent,
				deleteMasterEvent,
				putMasterEvent,
				masterevents,
				allevents,
				eventbynames,

				isLoading,
				setLoading,

				filterdiv,
				setFilterDiv,
				filtersubdiv,
				setFilterSubDiv,
				searchContact,
				setSearchContact,
				filterContact,
				setFilterContact,
				handleSearchContact,
				handleFilterByCompany,
				setDataFilterDropdown,
				dataFilterDropdown,
				setSelectedCompany,
				selectedCompany,
				forms,
				setForms,

				getUserReturnFCM,
				fcmtokens,
				userToSend,

				consultants,
				getConsultants,
				putConsultant,
				postConsultant,
				deleteConsultant,
				detailConsultant,
				getDetailConsultant,

				taxrates,
				taxRateDetail,
				getTaxRate,
				getTaxRatebyID,
				putTaxRate,
				postTaxRate,
				deleteTaxRate,

				contactPaten,
				getCpatentbyPage,
				getDataContactPaten,
			}}
			{...props}
		/>
	);
};

export default MasterDataProvider;
